import { useContext } from "react";
import AuthContext from "../context/auth.context";
// Hook to access auth context
export const useAuth = () => useContext(AuthContext);
